import React, { useState } from 'react'
import { Formik } from 'formik'
import { useDispatch } from 'react-redux'
import { Spin } from 'antd'
import Drawer from 'components/Drawer'
import Button from 'components/Button'
import ApplicationForm from 'modules/Roles/NewRoleCreation/Partials/RoleCreateForm/Partials/ApplicationForm'
import { editApplicationForm, getSingleRoleData } from 'modules/Roles/actions'
import styled from 'styled-components'

const DrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

const DrawerFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
  background: #fff;
`

const EditApplicationFormDrawer = ({
  visible,
  onClose,
  singleRoleData,
  jobId,
}) => {
  const dispatch = useDispatch()
  const [saving, setSaving] = useState(false)

  if (!singleRoleData?.applicationFormTemplate) return null

  const template = singleRoleData.applicationFormTemplate
  const initialValues = {
    applicationForm: {
      templateType: template.templateType || 'DIPLOMA',
      mandatoryQuestions: template.mandatoryQuestions || [],
      customQuestions: template.customQuestions || [],
    },
    elgibilty: { eligibilityCriteria: [] },
  }

  const handleSave = async (values) => {
    const appForm = values.applicationForm
    const payload = {
      mandatory: appForm.mandatoryQuestions || [],
      custom: appForm.customQuestions || [],
    }

    setSaving(true)
    const result = await dispatch(editApplicationForm(jobId, payload, null))
    setSaving(false)

    if (result?.status >= 200 && result?.status < 300) {
      dispatch(getSingleRoleData(0, jobId))
      onClose()
    }
  }

  return (
    <Formik initialValues={initialValues} enableReinitialize>
      {({ values, setFieldValue }) => (
        <Drawer
          width="80%"
          title="Edit Application Form"
          placement="right"
          visible={visible}
          closable
          onClose={onClose}
          destroyOnClose
          padding="0"
          content={
            <DrawerContent>
              <Spin spinning={saving} tip="Updating forms...">
                <ApplicationForm
                  roleData={{ ...singleRoleData, status: 0 }}
                  setFieldValue={setFieldValue}
                  selectedCourses={[]}
                  isEditMode
                />
              </Spin>
            </DrawerContent>
          }
          footer={
            <DrawerFooter>
              <Button.Secondary
                text="Cancel"
                onClick={onClose}
                disabled={saving}
              />
              <Button.Primary
                text={saving ? 'Saving...' : 'Save Changes'}
                onClick={() => handleSave(values)}
                disabled={saving}
              />
            </DrawerFooter>
          }
        />
      )}
    </Formik>
  )
}

export default EditApplicationFormDrawer
